import { render, staticRenderFns } from "./AdherenceIndicatorsGraphGDI.vue?vue&type=template&id=97468b4e&scoped=true&"
import script from "./AdherenceIndicatorsGraphGDI.vue?vue&type=script&lang=js&"
export * from "./AdherenceIndicatorsGraphGDI.vue?vue&type=script&lang=js&"
import style0 from "./AdherenceIndicatorsGraphGDI.vue?vue&type=style&index=0&id=97468b4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97468b4e",
  null
  
)

export default component.exports